class SelectValues {

  get(vm) {
    return (
{
  "gender": [
    { "id": "0", "value": "0", "label": vm.$t('CONTACT_GENDER_UNKNOWN'), "text": vm.$t('CONTACT_GENDER_UNKNOWN') },
    { "id": "1", "value": "1", "label": vm.$t('CONTACT_GENDER_MALE'), "text": vm.$t('CONTACT_GENDER_MALE') },
    { "id": "2", "value": "2", "label": vm.$t('CONTACT_GENDER_FEMALE'), "text": vm.$t('CONTACT_GENDER_FEMALE') }
  ]
}
    )
  }

}

const selectValues = new SelectValues()

export {
  selectValues
}
